import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurOilHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero-nuestro-aceite" className="relative w-full min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/our_oil_heritage_hero.png)]">
      <div className="absolute inset-0 bg-black/40" />

      <div ref={ref} className={cn("relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-800 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h1 className="font-serif text-[2.5rem] mb-6 leading-tight !text-[hsl(48,100%,96%)] !font-semibold md:text-[4rem]">Nuestro Aceite</h1>
        <p className="text-secondary font-sans text-lg md:text-xl max-w-3xl leading-relaxed">
          La esencia de nuestra tierra en cada gota. Un aceite de oliva virgen extra que respeta la tradición y destaca por su sabor auténtico.
        </p>
      </div>
    </section>;
}